const API_BASE_URL = 'https://admin.dh.mindflares.net/api';

export async function submitLead(lead, signal) {
  const response = await fetch(`${API_BASE_URL}/lead`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(lead),
    signal
  });

  if (!response.ok) {
    throw new Error('Failed to submit lead');
  }

  return response.json();
}
